module.exports = __webpack_public_path__ + "static/nestle-purina-depot-a6283895267c7e453a82d6c6237c2998.jpg";